<div>
    <app-sso-vehicle-verification [vin]="cachedVin" [isUserRegisterd]="isUserRegisterd"
        *ngIf="!verifiedVehicle; else confirmAccount"
        (verifiedVehicle)="verifiedVehicleCallback($event)"></app-sso-vehicle-verification>

    <ng-template #confirmAccount>
        <app-sso-confirm-account *ngIf="!isUserRegisterd"
            (confirmClick)="confirmAccountCallback($event)"></app-sso-confirm-account>
    </ng-template>

</div>